'use client';

import { useSearchParams } from 'next/navigation';
import { PromoBanner } from 'ui/components/PromoBanner/PromoBanner';
import { useTranslation } from '@whoop/i18n/lang/client';
import { BANNER_THEMES } from 'ui/types/PromoCodeThemes';
export const IsraelShippingBanner = (): JSX.Element | null => {
  const searchParams = useSearchParams();
  const {
    t
  } = useTranslation('upgradeError');
  const from = searchParams.get('from');
  if (from !== 'IL') {
    return null;
  }
  return <PromoBanner content={t('message.israel')} theme={BANNER_THEMES.black} data-sentry-element="PromoBanner" data-sentry-component="IsraelShippingBanner" data-sentry-source-file="IsraelShippingBanner.tsx" />;
};